// eslint-disable-next-line import/no-extraneous-dependencies
import { assignInlineVars } from "@vanilla-extract/dynamic"
import { getSpanStyles, tagSwitch } from "../../utils"
import { spanVars, contentStyle } from "../ContentBlock/ContentBlock.css"
import React from "react"
import type { CreateableContentBlockType } from "types/cms"

type Props = {
  headingSize: CreateableContentBlockType["tagType"]
  content: string
  fontColorMob: string
  fontColorDesktop: string
}

export const TagType: React.FC<Props> = ({
  headingSize,
  content,
  fontColorMob,
  fontColorDesktop,
}) => {
  const TagSize = tagSwitch(headingSize ?? "Paragraph") as React.ElementType
  const mobileStyles = getSpanStyles(fontColorMob)
  const desktopStyles = getSpanStyles(fontColorDesktop)
  return (
    <TagSize
      className={contentStyle}
      dangerouslySetInnerHTML={{ __html: content }}
      style={assignInlineVars(spanVars, {
        spanStylesMobile: { ...mobileStyles },
        spanStyleDesktop: { ...desktopStyles },
      })}
    />
  )
}
